import React from 'react';
import { useEditor, EditorContent, BubbleMenu, ReactRenderer } from '@tiptap/react';
import Mention from '@tiptap/extension-mention';
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import QuestionMentionList from './QuestionMentionList';
import tippy from 'tippy.js';

const TiptapQuestionReference = (props) => {
  const editor = useEditor({
    extensions: [
        Document,
        Paragraph,
        Text,
        Underline,
        StarterKit,
        Mention.configure({
            HTMLAttributes: {
                class: 'question_reference', //do not change without full understanding of our processor
            },
            renderText({ options, node }) {
                return `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
            },
            renderHTML({ options, node }) {
                return [
                    "span",
                    {
                        "data-id": node.attrs.id,
                        "data-label": node.attrs.label,
                        "data-type": "mention",
                        class: "question_reference"
                    },
                    `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`,
                ];
            },
            suggestion: {
                char: '@',
                decorationClass: 'interpretation_item',
                items: props.itemResource,
                render: renderQuestionMention
            }
        }),
        Link.configure({
          openOnClick: false,
          autolink: true,
        })
    ],
    content: props.value,
    onUpdate: updateParent,
  });

  function updateParent ({ editor }) {
    props.setValue(editor.getHTML());
  }

  function renderQuestionMention () {
    let component
    let popup

    return {
        onStart: props => {
            component = new ReactRenderer(QuestionMentionList, {
                props,
                editor: props.editor,
            })

            if (!props.clientRect) {
                return
            }

            popup = tippy('body', {
                getReferenceClientRect: props.clientRect,
                appendTo: () => document.body,
                content: component.element,
                showOnCreate: true,
                interactive: true,
                trigger: 'manual',
                placement: 'bottom-start',
            })
        },

        onUpdate(props) {
            component.updateProps(props)

            if (!props.clientRect) {
                return
            }

            popup[0].setProps({
                getReferenceClientRect: props.clientRect,
            })
        },

        onKeyDown(props) {
            if (props.event.key === 'Escape') {
                popup[0].hide()

                return true
            }

            return component.ref?.onKeyDown(props)
        },

        onExit() {
            popup[0].destroy()
            component.destroy()
        },
    }
  }

  const setLink = React.useCallback(() => {
    const previousUrl = editor.getAttributes('link').href
    const url = window.prompt('URL', previousUrl)

    // cancelled
    if (url === null) {
      return
    }

    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink()
        .run()

      return
    }

    // update link
    editor.chain().focus().extendMarkRange('link').setLink({ href: url })
      .run()
  }, [editor]);

  if (!editor) {
    return null
  }

  return (<>
        <div>
          <button className="bi-dash-circle danger btn btn-sm btn-danger" style={{ marginRight: 5 }} onClick={props.remove}></button>
          <u>Output</u>
        </div>
        
        
        <div className='TipTapEditor'>
          <EditorContent editor={editor} />
          {editor && <BubbleMenu editor={editor} tippyOptions={{ duration: 100 }}>
            <div className='btn-group' style={{ borderWidth: 2, borderStyle: 'solid', borderColor: 'black' }}>
              <button
                onClick={() => editor.chain().focus().toggleBold().run()}
                className={`${editor.isActive('bold') ? 'is-active' : ''} btn btn-sm btn-primary`}
              >
                <b>bold</b>
              </button>
              <button
                onClick={() => editor.chain().focus().toggleItalic().run()}
                className={`${editor.isActive('italic') ? 'is-active' : ''} btn btn-sm btn-primary`}
              >
                <i>italic</i>
              </button>
              <button
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                className={`${editor.isActive('strike') ? 'is-active' : ''} btn btn-sm btn-primary`}
              >
                <u>underline</u>
              </button>
              <button
                onClick={setLink}
                className={`${editor.isActive('link') ? 'is-active' : ''} btn btn-sm btn-primary`}
              >
                Set Link
              </button>
              <button
                onClick={() => editor.chain().focus().unsetLink().run()}
                disabled={!editor.isActive('link')}
                className={`${editor.isActive('link') ? 'is-active' : ''} btn btn-sm btn-primary`}
              >
                Unset Link
              </button>
            </div>
          </BubbleMenu>}
        </div>
    </>)
}

export default TiptapQuestionReference